import React, { createContext, useContext, useState, useCallback } from 'react';
import { useTheme } from '@mui/material/styles';

const ColorContext = createContext();

const STORAGE_CUSTOM_COLOR = 'custom_textColor';

export const ColorProvider = ({ children }) => {
    const theme = useTheme();
    const defaultColor = theme.palette.text.primary;

    const [customColor, setCustomColor] = useState(() => {
        try {
            return localStorage.getItem(STORAGE_CUSTOM_COLOR) || null;
        } catch (e) {
            return null;
        }
    });

    const textColor = customColor || defaultColor;

    const changeTextColor = useCallback((newColor) => {
        setCustomColor(newColor);
        try {
            if (newColor && newColor !== defaultColor) {
                localStorage.setItem(STORAGE_CUSTOM_COLOR, newColor);
            } else {
                localStorage.removeItem(STORAGE_CUSTOM_COLOR);
            }
        } catch (e) {}
    }, [defaultColor]);

    const resetToDefault = useCallback(() => {
        setCustomColor(null);
        try {
            localStorage.removeItem(STORAGE_CUSTOM_COLOR);
        } catch (e) {}
    }, []);

    return (
        <ColorContext.Provider value={{ 
            textColor, 
            changeTextColor, 
            resetToDefault,
            defaultColor,
            isCustom: Boolean(customColor && customColor !== defaultColor)
        }}>
            {children}
        </ColorContext.Provider>
    );
};

export const useTextColor = () => {
    const context = useContext(ColorContext);
    if (!context) {
        throw new Error('useTextColor must be used within a ColorProvider');
    }
    return context;
};
 